import { render, staticRenderFns } from "./InfoAboutSelectedCarrier.vue?vue&type=template&id=42a45f48&scoped=true"
import script from "./InfoAboutSelectedCarrier.vue?vue&type=script&lang=js"
export * from "./InfoAboutSelectedCarrier.vue?vue&type=script&lang=js"
import style0 from "./InfoAboutSelectedCarrier.vue?vue&type=style&index=0&id=42a45f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a45f48",
  null
  
)

export default component.exports